// extracted by mini-css-extract-plugin
export default {"inputGroup":"SearchBar-module__inputGroup--DP5xz","searchBox":"SearchBar-module__searchBox--RjamS"};